import { youtubeSource, ownedYoutubeEmbed } from "../../shared/youtube";
import { getVideoSource } from "../../services/videoSources";

export const externalVideoMessage = "Ainda não temos vídeo próprio deste assunto. Recomendamos este vídeo diretamente no YouTube.";
export const unverifiedVideoMessage = "Assista a este vídeo diretamente no YouTube.";

function recommendation(document, frame, video, source) {
  const link = document.createElement("a");
  link.href = video.url;
  link.target = "_blank";
  link.rel = "noopener noreferrer";
  link.setAttribute("data-dm-external-video", "true");
  link.style.cssText = "display:flex;flex-direction:column;align-items:center;justify-content:center;gap:12px;box-sizing:border-box;width:100%;min-height:220px;padding:24px;border-radius:12px;background:linear-gradient(135deg,#15373a,#24545b);color:#eef6f2;text-align:center;text-decoration:none;font:16px/1.5 Arial,sans-serif";
  // Mantém o espaço do player original, inclusive dentro de caixas 16:9.
  for (const property of ["position", "inset", "top", "right", "bottom", "left", "width", "height", "max-width", "max-height", "margin", "aspect-ratio"]) {
    const value = frame.style.getPropertyValue(property);
    if (value) link.style.setProperty(property, value);
  }
  if (frame.style.position === "absolute") {
    link.style.minHeight = "0";
    link.style.overflow = "auto";
  }
  for (const text of [source.notice || (source.ownership === "external" ? externalVideoMessage : unverifiedVideoMessage),
    source.author ? `Canal: ${source.author}` : ""]) {
    if (!text) continue;
    const item = document.createElement("span");
    item.textContent = text;
    link.append(item);
  }
  const action = document.createElement("span");
  action.style.cssText = "display:flex;align-items:center;justify-content:center;gap:12px;max-width:100%;box-sizing:border-box;padding:14px 22px;border-radius:12px;background:#d90909;color:#fff;font-size:18px;font-weight:700;line-height:1.3;box-shadow:0 4px 14px #0003";
  const play = document.createElement("span");
  play.textContent = "▶";
  play.setAttribute("aria-hidden", "true");
  play.style.cssText = "font-size:26px;line-height:1";
  action.append(play, document.createTextNode("Assistir no YouTube ↗"));
  link.append(action);
  return link;
}

// Substitui o player ANTES de o srcDoc chegar à tela. A revisão das respostas
// é calculada sobre o HTML original, para preservar todo o progresso existente.
export async function prepareExternalVideos(html, signal) {
  const document = new DOMParser().parseFromString(html, "text/html");
  const players = [...document.querySelectorAll("iframe[src]")]
    .map((frame) => ({ frame, video: youtubeSource(frame.getAttribute("src")) }))
    .filter(({ video }) => video);
  if (!players.length) return html;
  const results = await Promise.all(players.map(async ({ frame, video }) => {
    const source = await getVideoSource(video.videoId);
    return { frame, video, source };
  }));
  if (signal?.aborted) throw new DOMException("Preparação cancelada.", "AbortError");
  let changed = false;
  for (const { frame, video, source } of results) {
    if (source.ownership === "owned") {
      const safeEmbed = ownedYoutubeEmbed(frame.getAttribute("src"));
      if (safeEmbed !== frame.getAttribute("src")) {
        frame.setAttribute("src", safeEmbed);
        changed = true;
      }
      continue;
    }
    frame.replaceWith(recommendation(document, frame, video, source));
    changed = true;
  }
  return changed ? (document.doctype ? "<!doctype html>" : "") + document.documentElement.outerHTML : html;
}
